import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";

export function UserFormDialog({ open, onOpenChange, editingUser, form, setForm, onSubmit }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="bg-card border-border max-w-lg">
                <DialogHeader>
                    <DialogTitle style={{ fontFamily: "Outfit" }}>
                        {editingUser ? "Edit User" : "Create Assessment User"}
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-2">
                    <div className="grid grid-cols-2 gap-3">
                        <div className="space-y-1">
                            <Label className="text-xs">Full Name</Label>
                            <Input data-testid="user-name-input" value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-background border-border" />
                        </div>
                        {!editingUser && (
                            <div className="space-y-1">
                                <Label className="text-xs">Email</Label>
                                <Input data-testid="user-email-input" type="email" value={form.email}
                                    onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-background border-border" />
                            </div>
                        )}
                    </div>
                    {!editingUser && (
                        <div className="space-y-1">
                            <Label className="text-xs">Password</Label>
                            <Input data-testid="user-password-input" type="password" value={form.password}
                                onChange={(e) => setForm({ ...form, password: e.target.value })} className="bg-background border-border" />
                        </div>
                    )}
                    <div className="grid grid-cols-2 gap-3">
                        <div className="space-y-1">
                            <Label className="text-xs">Organization</Label>
                            <Input value={form.organization} onChange={(e) => setForm({ ...form, organization: e.target.value })}
                                className="bg-background border-border" />
                        </div>
                        <div className="space-y-1">
                            <Label className="text-xs">Department</Label>
                            <Input value={form.department} onChange={(e) => setForm({ ...form, department: e.target.value })}
                                className="bg-background border-border" />
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div className="space-y-1">
                            <Label className="text-xs">Designation</Label>
                            <Input value={form.designation} onChange={(e) => setForm({ ...form, designation: e.target.value })}
                                className="bg-background border-border" />
                        </div>
                        <div className="space-y-1">
                            <Label className="text-xs">Employee ID</Label>
                            <Input value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })}
                                className="bg-background border-border" />
                        </div>
                    </div>
                    <div className="space-y-1">
                        <Label className="text-xs">Reporting Manager</Label>
                        <Input value={form.reporting_manager} onChange={(e) => setForm({ ...form, reporting_manager: e.target.value })}
                            className="bg-background border-border" />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
                    <Button data-testid="user-form-submit" onClick={onSubmit} style={{ backgroundColor: "#4A7AB5" }}>
                        {editingUser ? "Update" : "Create"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
